import { forwardRef, useState, useEffect, useRef } from 'react'
import './ContextMenu.scss'
import { Skeleton, Modal, Dropdown, Menu } from 'antd'
import WeaverService from 'Services/WeaverService'
import Feather from '@sysunite/react-feather'

{ Item, SubMenu, ItemGroup, Divider} = Menu

ContextMenu = ({ loading = false, actions, children }) ->
  [visible, setVisible] = useState(false)

  getValue = (item) ->
    if typeof item is 'function'
      item()
    else
      item

  hiddenFilter = (items) ->
    _.filter(items, ({ hidden, requiresWriteAccess }) ->
      not getValue(hidden) and if requiresWriteAccess then WeaverService.userCanEdit() else true
    )

  confirmOnClick = ({ confirmationTitle, onClick }) -> ({ domEvent }) ->
    setVisible(false)
    Modal.confirm({
      title: getValue(confirmationTitle) or 'Are you sure?'
      icon: <span className="anticon"><Feather type="alert-circle" /></span>
      okText: 'Yes'
      okType: 'danger'
      cancelText: 'No'
      onOk: (args...) ->
        onClick(args...)
        false
    })
    domEvent.stopPropagation()

  generateItem = ({
    key,
    title,
    divider,
    group,
    submenu,
    danger,
    onClick,
    icon,
    disabled,
    requiresConfirmation,
    confirmationTitle
  }, index) ->
    if requiresConfirmation
      onOk = confirmOnClick({ confirmationTitle, onClick })
    else
      onOk = (args...) ->
        setVisible(false)
        onClick(args...)

    if submenu? and hiddenFilter(submenu).length > 0
      <SubMenu key={key}
               data-testid={key}
               icon={icon}
               title={getValue(title)}>
        { hiddenFilter(submenu).map(generateItem) }
      </SubMenu>
    else if group?
      <ItemGroup key={key}
                 data-testid={key}
                 title={getValue(title)}>
        { hiddenFilter(group).map(generateItem) }
      </ItemGroup>
    else if not submenu? and not group?
      <Item key={key}
            data-testid={key}
            icon={icon}
            disabled={getValue(disabled)}
            onClick={onOk}
            danger={danger}>
        { getValue(title) }
      </Item>

  <Dropdown
    visible={not loading and visible}
    onVisibleChange={setVisible}
    overlay={
      <Menu
        onContextMenu={(e) -> e.preventDefault()}
        data-testid="context-menu">
        { hiddenFilter(actions).map(generateItem) }
      </Menu>
    }
    data-testid="context-menu"
    trigger={['contextMenu']}>
    { children }
  </Dropdown>

export default ContextMenu
